/* eslint-disable arrow-parens */
/* eslint-disable max-len */
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {
  Badge,
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Table,
  Button, 
  Modal, 
  ModalHeader, 
  ModalBody, 
  ModalFooter,
} from 'reactstrap';
import { RTLProps } from '@/shared/prop-types/ReducerProps';
import { useQuery } from 'react-query';
import axios from 'axios';
import { useCookies } from 'react-cookie';

const Consignor = ({ rtl }) => {
  const { t } = useTranslation('common');
  const [cookies, setCookie] = useCookies(['tranAuthToken']);
  const [modal, setModal] = useState(false);
  const [emailToBeDeleted, setemailToBeDeleted] = useState('');
  const toggle = () => setModal(!modal);

  const {
    data, isLoading, isFetching, isError,
  } = useQuery(
    'allConsignors',
    () => axios.get('https://orca-app-5i5qx.ondigitalocean.app/api/admin/consignor/list', {
      headers: {
        Authorization: `Bearer ${cookies.tranAuthToken}`,
      },
    }),
  );
  if (data && !isLoading && !isFetching && !isError) {
    // console.log(data.data.list[0].consignor);
    // console.log('consignor', data.data.list[0]);
  }

  // console.log('data', data.data.list[0].address[0]);

  function gettingEmailForDeleting(email) {
    setemailToBeDeleted(email);
  }

  async function deletingUser(email) { 
    const emailData = JSON.stringify({
      email: `${email}`,
    });
  
    const config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: 'https://orca-app-5i5qx.ondigitalocean.app/api/admin/delete/user',
      headers: { 
        Authorization: `Bearer ${cookies.tranAuthToken}`, 
        'Content-Type': 'application/json',
      },
      data: emailData,
    };

    await axios(config).then(response => console.log(response.data)).catch((error) => console.log(error));
  }

  return (
    <Container className="dashboard">
      <Row>
        <Col md={12}>
          {/* <h3 className="page-title">{t('booking_dashboard.page_title')}</h3> */}
          <h3 className="page-title">Consignor</h3>
        </Col>
      </Row>
      <Row>
        <Col md={12} lg={12}>
          <Card>
            <CardBody>
              <div className="card__title">
                <h5 className="bold-text">Consignor Table</h5>
                {/* <h5 className="subhead">Use default table with property
                  <span className="red-text">responsive
                  </span>
                </h5> */}
              </div>
              <Table responsive hover className="table--bordered">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>User Name</th>
                    <th>Admin Name</th>
                    <th>Contact</th>
                    <th>Email</th>
                    <th>GST No.</th>
                    <th>PAN No. Time</th>
                    <th>Time</th>
                    <th>Address</th>
                    <th>Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {isFetching && <tr><td>Loading...</td></tr>}
                  {!isLoading && !isError && data && data.data.list && data.data.list.map((item, index) => (
                    <tr>
                      <td>{index + 1}</td>
                      <td>{item.consignor.userName}</td>
                      <td>{item.consignor.adminName}</td>
                      <td>{item.consignor.contact}</td>
                      <td>{item.consignor.email}</td>
                      <td>{item.consignor.gstNumber}</td>
                      <td>{item.consignor.panNumber}</td>
                      <td>{new Date(item.consignor.createdAt).toLocaleDateString()}</td>
                      <td>{item.address[0].address},{item.address[0].district},{item.address[0].location},{item.address[0].pincode},{item.address[0].state}</td> 
                      <td>{item.consignor.status ? <p style={{ fontWeight: 'bold' }}>True</p> : <p style={{ fontWeight: 'bold' }}>False</p>}</td>
                      <td>{item.consignor.status ? <Badge onClick={() => { gettingEmailForDeleting(item.consignor.email); toggle(); }} color="danger" size="sm">Delete</Badge> : <Badge disabled color="secondary" size="sm">Delete</Badge>}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </CardBody>
          </Card>
        </Col>
      </Row>
      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>User Deletion</ModalHeader>
        <ModalBody> 
          Do you want to delete {emailToBeDeleted}?
        </ModalBody>
        <ModalFooter cssModule={{ justifyContent: 'center' }}>
          <Button color="primary" onClick={() => { deletingUser(emailToBeDeleted); toggle(); }}>
            Delete
          </Button>{' '}
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </Container>
  );
};

Consignor.propTypes = {
  rtl: RTLProps.isRequired,
};

export default connect((state) => ({
  rtl: state.rtl,
}))(Consignor);
